import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 48,
    background: '#3A3A3A',
    padding: theme.spacing(0, 2),
    borderRadius: 4,
    width: '100%',
  },
  inputStyling: {
    color: theme.palette.common.white,
    width: '100%',
  },
  searchIcon: {
    color: theme.palette.common.white,
  },
  clearIcon: {
    color: theme.palette.common.white,
  },
}));
